import React, { useEffect, useState } from "react";
import styles from "./TransactionPeriod.module.scss";
import { getCurrentSessionTransactionPeriod } from "api";
import { formatDate } from "@progress/kendo-intl";
import { useCompany } from "services/companyService";
import { arrowRotateCwIcon } from "@progress/kendo-svg-icons";
import { SvgIcon } from "@progress/kendo-react-common";

export const TransactionPeriod = ({
    onRefreshTransactionPeriod,
    showReload = true,
    customStyles,
}) => {
    const { data: company } = useCompany();
    const locale = company?.locale;
    const [currentTransactionPeriod, setCurrentTransactionPeriod] = useState();

    const getTransactionPeriodText = (currentTransactionPeriod) => {
        if (!currentTransactionPeriod) {
            return {
                color: "red",
                text: "Invalid Transaction Period",
            };
        }

        if (!currentTransactionPeriod?.closed) {
            return {
                color: "blue",
                text: dateReturner(),
            };
        } else if (currentTransactionPeriod?.closed) {
            return {
                color: "red",
                text: `${dateReturner()} Closed`,
            };
        }
    };

    const getCurrentTransactionPeriod = async () => {
        try {
            const data = await getCurrentSessionTransactionPeriod(
                JSON.parse(sessionStorage.getItem("sessionPeriod"))?.period
            );
            setCurrentTransactionPeriod(data.data?.data);
            if (onRefreshTransactionPeriod) {
                onRefreshTransactionPeriod(data.data?.data);
            }
        } catch (error) {
            console.log("getCurrentTransactionPeriod error", error);
        }
    };

    const dateReturner = () => {
        const safeLocale = locale || "en-US";

        return `${currentTransactionPeriod?.period} ( ${formatDate(
            new Date(currentTransactionPeriod?.startDate),
            "d",
            safeLocale
        )} - ${formatDate(
            new Date(currentTransactionPeriod?.endDate),
            "d",
            safeLocale
        )} )`;
    };

    useEffect(() => {
        getCurrentTransactionPeriod();
    }, []);

    return (
        <div
            className={`${styles["container"]} d-flex align-items-center ${customStyles ? customStyles : " justify-content-end pe-4"
                } `}
            style={{
                color: getTransactionPeriodText(currentTransactionPeriod).color,
            }}
        >
            <div>
                {" "}
                Transaction Period:{" "}
                {getTransactionPeriodText(currentTransactionPeriod).text}
            </div>
            {showReload && (
                <span
                    className={`${styles.reloadIcon} d-flex cursor-pointer ms-2`}
                    onClick={getCurrentTransactionPeriod}
                >
                    <SvgIcon
                        icon={arrowRotateCwIcon}
                        style={{
                            color: getTransactionPeriodText(currentTransactionPeriod).color,
                        }}
                    />
                </span>
            )}
        </div>
    );
};
